<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">PAINEL DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-6 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Itens exibidos:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Consultar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstcontas"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                        <button type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" @click.prevent="mtddefinirnossonumero(item.row.id)" title="Definir sequência nosso número"><i class="fa fa-list-ol"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Itens exibidos
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstcontas.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Criar</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">ID interno:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="eddescricao">*Nome de referência:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="cbbancos">*Banco:</label>
								<select id="cbbancos" v-model="vidbanco" v-bind:disabled="ativadesativa"
										data-placeholder="Selecione uma opção" data-allow-clear="true"
										style="width:100%;">
								</select>
							</div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edagencia">Agência:</label>
                                <input type="text" v-model="vagencia" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edagencia"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <label for="eddigagencia">Dig:</label>
                                <input type="text" v-model="vdigagencia" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="eddigagencia"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edconta">Conta:</label>
                                <input type="text" v-model="vconta" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edconta"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <label for="eddigconta">Dig:</label>
                                <input type="text" v-model="vdigconta" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="eddigconta"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edcedente">Cedente:</label>
                                <input type="text" v-model="vcedente" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edcedente"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <label for="eddigcedente">Dig:</label>
                                <input type="text" v-model="vdigcedente" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="eddigcedente"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edbeneficiario">Beneficiário:</label>
                                <input type="text" v-model="vcodbeneficiario" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edbeneficiario"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <label for="eddigbeneficiario">Dig:</label>
                                <input type="text" v-model="vdigbeneficiario" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="eddigbeneficiario"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edpraca">Praça:</label>
                                <input type="text" v-model="vpraca" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edpraca"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <label for="eduf">UF:</label>
                                <input type="text" v-model="vuf" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="eduf"  maxlength="2"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edcnpj">CNPJ:</label>
                                <input type="text" v-mask="'##.###.###/####-##'" v-model="vcnpjcpf" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edcnpj"  maxlength="20">
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-5">
                                <label for="edemitente">Emitente:</label>
                                <input type="text" v-model="vemitente" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edemitente"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <label for="edcarteira">Carteira:</label>
                                <input type="text" v-model="vcarteira" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edcarteira"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <label for="edvariacaocarteira">Variação:</label>
                                <input type="text" v-model="vvariacaocarteira" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edvariacaocarteira"  maxlength="3"
                                    style="text-transform: uppercase;" title="Somente para Banco do Brasil">
                            </div>                            
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="edconvenio">Convênio:</label>
                                <input type="text" v-model="vconvenio" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edconvenio"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="edinstrucao1">Instrução(1):</label>
                                <input type="text" v-model="vinstrucao1" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edinstrucao1"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="edinstrucao2">Instrução(2):</label>
                                <input type="text" v-model="vinstrucao2" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edinstrucao2"  maxlength="50"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddiasprotesto">Dias protesto:</label>
                                <input type="number" v-model="vdiasprotesto" v-bind:disabled="ativadesativa" min="0"
                                    class="form-control form-control-sm" id="eddiasprotesto"  maxlength="11"
                                    style="text-align: right;">
                            </div>
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <label for="edespeciedoc">Espécie:</label>
                                <input type="text" v-model="vespeciedoc" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edespeciedoc"  maxlength="2"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="cbaceite">Aceite:</label>
                                <select class="form-control form-control-sm" id="cbaceite" v-model="vaceite" v-bind:disabled="ativadesativa">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="cblayoutremessa">Layout remessa:</label>
                                <select class="form-control form-control-sm" id="cblayoutremessa" v-model="vlayoutremessa" v-bind:disabled="ativadesativa">
                                    <option value="0">cnab240</option>
                                    <option value="1">cnab240_SIACC</option>
                                    <option value="2">cnab240_SIGCB</option>
                                    <option value="3">cnab400</option>
                                </select>
                            </div>                            
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="cbapibanco">API Banco:</label>
                                <select class="form-control form-control-sm" id="cbapibanco" v-model="vapibanco" v-bind:disabled="ativadesativa">
                                    <option value="0">Nenhum</option>
                                    <option value="1">Banco Inter</option>
                                </select>
                            </div>                                                        
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos obrigatórios são sinalizados com \*</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Salvar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Editar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Remover
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" id="mddefinirnossonumero">
            <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">            
                <div class="modal-header">
                    <h4 class="modal-title">Definir nosso número</h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <label for="ednossonumero">Sequência nosso número:</label>
                            <input type="number" class="form-control form-control-sm" id="ednossonumero" v-model="vnossonumero" maxlength="11"/>
                        </div>                        
                    </div>
                </div>
                <div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtconfirmarnossonumero()"><i class="fa fa-check"></i> Confirmar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                </div>                
            </div>
            </div>
        </div>        
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import Swal from "sweetalert2/dist/sweetalert2.js"
    import "sweetalert2/dist/sweetalert2.min.css"
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadcontasbancarias',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                lstcontas  : [],
                pfiltro      : 1,
                pconteudo    : '',
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                opcrud              :  0,
                vid                 : '',
                vdescricao          : '',
                vidbanco            : null,
                vagencia            : '',
                vdigagencia         : '',
                vconta              : '',
                vdigconta           : '',
                vcedente            : '',
                vdigcedente         : '',
                vcodbeneficiario    : '',
                vdigbeneficiario    : '',
                vpraca              : '',
                vuf                 : '',
                vcnpjcpf            : '',
                vemitente           : '',
                vcarteira           : '',
                vconvenio           : '',
                vinstrucao1         : '',
                vinstrucao2         : '',
                vmsgboleto          : '',
                vlocalpagamento     : '',
                vdiasprotesto       : 0,
                vespeciedoc         : '',
                vaceite             : 1,
                vlayoutremessa      : 3,
                vapibanco           : 0, 
                vvariacaocarteira   : '',                    

                vnossonumero        : 1,
                vidcontadefns       : 0,
                //variável para habilitação dos campos
                ativadesativa       : true,

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'CONTAS BANCÁRIAS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-conta",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Banco",
                        name: "descbanco",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Id.",
                        name: "codigo",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Agência",
                        name: "agencia",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Conta",
                        name: "conta",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and c.id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(c.descricao) like upper("'+this.pconteudo+'%")';
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregacontas(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregacontas(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                retorno.then(function (response) {
                    vself.lstcontas = response.data.lista;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstcontas = [];
                    loader.hide();
                });
            },
			mtdselect2_def(){
                let vself  = this;
				$('#mddefinirnossonumero').on('shown.bs.modal', function (e) {
                    let loader      = vself.$loading.show();
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : ""},
                        {parametro: 'codencontrar', valor : vself.vidcontadefns},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.vnossonumero = response.data.nossonumero;
                        $('#ednossonumero').focus();
                    }).catch(function (response) {
                        loader.hide();
                    });                    					
                });            
                    
				$("#cbbancos").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbbancos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidbanco = $("#cbbancos").val();
				});
			},            
            resetarDados() {
                util.toTop();
                this.vid                = '';
                this.vdescricao         = '';
                this.vidbanco			= null;
                this.vagencia			= '';
                this.vdigagencia		= '';
                this.vconta         	= '';
                this.vdigconta          = '';
                this.vcedente         	= '';
                this.vdigcedente        = '';
                this.vcodbeneficiario   = '';
                this.vdigbeneficiario   = '';
                this.vpraca         	= '';
                this.vuf         		= '';
                this.vcnpj           	= '';
                this.vemitente          = '';
                this.vcarteira          = '';
                this.vconvenio          = '';
                this.vinstrucao1        = '';
                this.vinstrucao2        = '';
                this.vdiasprotesto      = 0;
                this.vespeciedoc        = '';
                this.vaceite          	= 1;
                this.vlayoutremessa     = 3;
                this.vapibanco          = 0;
                this.vvariacaocarteira  = '';
                
                $("#cbbanco").val(null).trigger('change');
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('002Z.030M.010Z', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE CONTAS BANCÁRIAS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstcontas = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                Swal.fire({
                    customClass: {
                        confirmButton: "btn btn-success conf",
                        cancelButton: "btn btn-danger"
                    },
                    title: "Confirmação",
                    text: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Fechar"
                }).then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        vself.mtdregistro();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and c.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data.lista[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('002Z.030M.020Z', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE CONTAS BANCÁRIAS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('002Z.030M.030Z', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE CONTAS BANCÁRIAS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                this.vid                 = registro.id;
                this.vdescricao          = registro.descricao;
                this.vidbanco			 = registro.idbanco;
                this.vagencia			 = registro.agencia;
                this.vdigagencia		 = registro.digagencia;
                this.vconta         	 = registro.conta;
                this.vdigconta           = registro.digconta;
                this.vcedente         	 = registro.cedente;
                this.vdigcedente         = registro.digcedente;
                this.vcodbeneficiario    = registro.codbeneficiario;
                this.vdigbeneficiario    = registro.digbeneficiario;
                this.vpraca         	 = registro.praca;
                this.vuf         		 = registro.uf;
                this.vcnpjcpf         	 = registro.cnpjcpf;
                this.vemitente           = registro.emitente;
                this.vcarteira           = registro.carteira;
                this.vconvenio           = registro.convenio;
                this.vinstrucao1         = registro.instrucao1;
                this.vinstrucao2         = registro.instrucao2;
                this.vdiasprotesto       = registro.diasprotesto;
                this.vespeciedoc         = registro.especiedoc;
                this.vaceite          	 = registro.aceite;
                this.vlayoutremessa      = registro.layoutremessa;
                this.vapibanco           = registro.apibanco;
                this.vvariacaocarteira   = registro.variacaocarteira;
                
                var defbanco    = new Option(registro.descbanco, this.vidbanco, true, true);
                $('#cbbancos').append(defbanco).trigger('change');                
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : this.vid,
                    'descricao'         : this.vdescricao,
                    'idbanco' 			: this.vidbanco,
                    'agencia' 			: this.vagencia,
                    'digagencia' 		: this.vdigagencia,
                    'conta' 			: this.vconta,
                    'digconta' 			: this.vdigconta,
                    'cedente' 			: this.vcedente,
                    'digcedente' 		: this.vdigcedente,
                    'codbeneficiario' 	: this.vcodbeneficiario,
                    'digbeneficiario' 	: this.vdigbeneficiario,
                    'praca' 			: this.vpraca,
                    'uf' 				: this.vuf,
                    'cnpjcpf' 			: this.vcnpjcpf,
                    'emitente' 			: this.vemitente,
                    'carteira' 			: this.vcarteira,
                    'convenio' 			: this.vconvenio,
                    'instrucao1' 		: this.vinstrucao1,
                    'instrucao2' 		: this.vinstrucao2,
                    'msgboleto' 		: this.vmsgboleto,
                    'localpagamento'	: this.vlocalpagamento,
                    'diasprotesto' 		: this.vdiasprotesto,
                    'especiedoc' 		: this.vespeciedoc,
                    'aceite' 			: this.vaceite,
                    'layoutremessa' 	: this.vlayoutremessa,
                    'apibanco'          : this.vapibanco,
                    'variacaocarteira'  : this.vvariacaocarteira
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '002Z.030M.010Z' : parseInt(this.opcrud) === 2 ? '002Z.030M.020Z' : '002Z.030M.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        util.notif("success", 'Registro processado com sucesso!')
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregacontas(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                util.notif("warning", response.data.substring(4))
                                break;
                            case 'E': default:
                                util.notif("error", response.data.substring(4))
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                });
            },
            mtddefinirnossonumero(idconta){
                this.vidcontadefns = idconta;
                $('#mddefinirnossonumero').modal('show');
            },
            mtconfirmarnossonumero(){
                let vself = this;
                if (vself.vnossonumero === ''){               
                    util.notif("warning", 'Campo Nosso Número deve ser informado!');
                    $('#ednossonumero').focus();
                    return;
                }
                Swal.fire({
                    customClass: {
                        confirmButton: "btn btn-success conf",
                        cancelButton: "btn btn-danger"
                    },
                    title: "Confirmação",
                    text: 'Esse processo irá reiniciar o contador do campo "Nosso Número" para emissão dos boletos desta conta. Confirma esta operação?',
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Fechar"
                }).then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'definenossonumero'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'id',           valor : vself.vidcontadefns},
                            {parametro: 'nossonumero',  valor : vself.vnossonumero}
                        ];
                        let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontasbancarias.php');
                        retorno.then(function (response) {
                            loader.hide();
                            if ($.isNumeric(response.data)){
                                util.notif("success", 'Registro processado com sucesso!')
                                $('#mddefinirnossonumero').modal('hide');
                            }else{
                                let tpret = response.data.substring(0,1);
                                switch (tpret) {
                                    case 'I':
                                        util.notif("warning", response.data.substring(4))
                                        break;
                                    case 'E': default:
                                        util.notif("error", response.data.substring(4))
                                        break;
                                }
                            }
                        }).catch(function (response) {
                            loader.hide();
                        });    
                    } else {
                        $('#btgravar').focus();
                    }
                });                
            }
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('002Z.030M', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtdexecutapesquisa();
                        vself.mtdselect2_def();
                    } else {
                        util.notif("warning", 'Acesso não permitido para o usuário!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdescricao === '' ;
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregacontas(val);
            }
        }
    }
</script>
<style>
    .def-col-opcoes-conta{
        width: 140px !important;
    }
    .def-col-cod{
        width: 80px !important;
    }
</style>